import { useAuth0 } from "@auth0/auth0-react";
import LogoImage from "assets/images/logos/Logo.svg";
import { InputField } from "components";
import { useFormik } from "formik";
import AuthService from "Lib/API/Auth";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import "./index.scss";

const ForgetPassword = () => {
  // const LogoImage = useSelector((state) => state.homeReducer.headerLogo);
  const history = useHistory();

  const [loading, setLoading] = React.useState(false);

  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (localStorage.getItem("isLoggedIn") == "true") history.push("/home");
  }, []);

  const initialValues = {
    // user_first_name: "",
    user_email_address: "",
  };

  const [showError, setShowError] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    // validationSchema: AddNewMemberSchema,
    onSubmit: async (values) => {
      setLoading(true);

      const payload = {
        email: values?.user_email_address,
      };

      if (values?.user_email_address != "") {
        await AuthService.postforgotpassword(payload /* token*/)
          .then((res) => {
            toastr.success("Success", "Reset link has been sent to your email");
            setTimeout(() => {
              history.push("/");
            }, 3000);
          })
          .catch((err) => {
            setLoading(false);
            toastr.error("Error", err.data.message);
          });
      } else {
        setShowError(true);
        setLoading(false);
      }
    },
  });

  return (
    <>
      <div className="container-flex">
        <div className="row Auth-form-container">
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework"
          >
            <div className="Auth-form">
              <div className="Auth-form-content">
                <div className="form-group mt-3 Auth-form-title mb-0">
                  <img src={LogoImage} width="200px" />
                </div>
                <p className="Auth-form-title mt-2">Forget Password</p>
                <div className="form-group mt-1">
                  <InputField
                    {...{
                      formik,
                      title: "Email address",
                      name: "user_email_address",
                      placeholder: "Enter your email",
                      checkValidation: true,
                      value: formik.values?.user_email_address,
                    }}
                  />
                  {showError && (
                    <p
                      style={{
                        color: "red",
                      }}
                    >
                      Required!
                    </p>
                  )}
                </div>

                <div className="d-grid gap-2 mt-5 send-button">
                  <button
                    className="btn-primary btn login-btn-link"
                    onSubmit={formik.handleSubmit}
                    type="submit"
                  >
                    Send
                    {loading ? (
                      <span className="ml-3 spinner spinner-white"></span>
                    ) : (
                      ""
                    )}
                  </button>
                </div>
                {/* <div className="mt-5 text-center">
                <span className="account-text">You don’t have an account?</span>
                <span className="">
                  <button
                    type="button"
                    id="btn-signup"
                    className="btn signup-link"
                  >
                    <strong>Sign up</strong>
                  </button>
                </span>
              </div> */}
              </div>
            </div>
          </form>
          <div className="col-12 mt-1 text-center">
            <h3>
              <span className="mr-1 powered-text"> Powered by </span>
              <span>
                <a href="">
                  <img src={LogoImage} className="Org-logo" alt="Org-logo" />
                </a>
              </span>
            </h3>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
